function toggleDarkTheme(darkMode: boolean): void {
	document.body.classList.toggle('darkMode', darkMode);
}

export function detectPreferredColorScheme() {
	// Use matchMedia to check the user preference
	const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

	toggleDarkTheme(prefersDark.matches);

	// Listen for changes to the prefers-color-scheme media query
	prefersDark.addEventListener('change', (event: MediaQueryListEvent) => toggleDarkTheme(event.matches));
}
